import "@/styles/globals.css";
import { usePathname } from "@/lib/navigation";
import { AuthContextProvider } from "@/context/AuthContext";
import { NotificationProvider } from "@/context/NotificationContext";
import { SearchProvider } from "@/context/SearchContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import OnboardingChecklist from "@/components/OnboardingChecklist";
import CookieConsent from "@/components/CookieConsent";
import LoadingSpinner from "@/components/LoadingSpinner";
import SiteMetadata from "@/components/SiteMetadata";
import {
  OrganizationStructuredData,
  WebApplicationStructuredData,
  WebSiteStructuredData,
} from "@/components/StructuredData";
import { DarkModeProvider } from "@/context/DarkModeContext";
import { Outlet } from "react-router-dom";

export default function RootLayout() {
  const pathname = usePathname();
  const isAdminRoute = pathname?.startsWith("/admin");

  return (
    <DarkModeProvider>
      <AuthContextProvider>
        <NotificationProvider>
          <SearchProvider>
            <LoadingSpinner />
            <SiteMetadata />
            <OrganizationStructuredData />
            <WebSiteStructuredData />
            <WebApplicationStructuredData />
            <div className="pageWrapper">
              {!isAdminRoute && <Header />}
              <Outlet />
              <OnboardingChecklist />
              {!isAdminRoute && <Footer />}
              <CookieConsent />
            </div>
          </SearchProvider>
        </NotificationProvider>
      </AuthContextProvider>
    </DarkModeProvider>
  );
}
